import React, { useEffect } from 'react';

const Awards = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const categories = [
    { num: "01", name: "Top LinkedIn Creator (Cameroon)", icon: "✍️" },
    { num: "02", name: "Most Engaging Recruiter", icon: "🤝" },
    { num: "03", name: "Youth Leadership Award", icon: "🌟" },
    { num: "04", name: "Tech Innovator of the Year", icon: "💻" },
    { num: "05", name: "Outstanding Woman in Business", icon: "👩‍💼" },
    { num: "06", name: "Best Student Profile", icon: "🎓" },
    { num: "07", name: "Digital Marketer of the Year", icon: "📱" },
    { num: "08", name: "Startup Founder of the Year", icon: "🚀" },
    { num: "09", name: "Community Builder Award", icon: "🏘️" },
    { num: "10", name: "Corporate Social Responsibility (Brand)", icon: "🏆" }
  ];

  return (
    <>
      <section className="page-hero">
        <div className="container page-hero__content">
          <h1 className="page-hero__title">LLC 2026 Awards</h1>
          <div className="breadcrumb">
            <a href="/">Home</a> <span>/</span> Awards
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="text-center">
            <div className="eyebrow" style={{justifyContent: 'center'}}>Excellence Recognized</div>
            <h2 className="section-title">Award Categories</h2>
            <p className="section-body" style={{maxWidth: 600, margin: '0 auto'}}>
              We celebrate the professionals, creators, and brands that are making significant impacts in their respective fields. Browse the categories and prepare your nominations!
            </p>
          </div>

          <div className="awards-grid">
            {categories.map(cat => (
              <div key={cat.num} className="award-item">
                <div className="award-num">{cat.num}</div>
                <div className="award-icon">{cat.icon}</div>
                <div className="award-name">{cat.name}</div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <p className="section-body mb-4"><strong>Nominations are currently closed. Check back soon.</strong></p>
            <button className="btn btn-red" disabled style={{opacity: 0.6, cursor: 'not-allowed'}}>Nominate Someone</button>
          </div>
        </div>
      </section>
    </>
  );
};

export default Awards;
